import React, { useEffect } from 'react'
import { Box, Flex, Text } from '@chakra-ui/react'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import * as eva from 'eva-icons'
import { isCardExpired } from '../../utils/utils'
import { useTranslation } from 'react-i18next'
import { PaymentMethodIcon } from './PaymentMethodIcon'

interface IPaymentCardProps {
  brand: string
  last4: string
  owner: string
  expirationDate: string
}

function PaymentInfo({ brand, last4, owner, expirationDate }: IPaymentCardProps): JSX.Element {
  const { t } = useTranslation()
  useEffect(() => {
    eva.replace()
  }, [])
  const isExpired = isCardExpired(expirationDate)
  return (
    <Box width={260}>
      <Flex alignItems='center' mb={2}>
        <PaymentMethodIcon brand={brand} />
        <Flex alignItems='left' direction={'column'} marginLeft={'10px'}>
          <Text fontWeight='400' fontSize='16px' lineHeight='22.4px' color='neutralDark'>
            **** **** **** {last4}
          </Text>
          <Text fontWeight='300' fontSize='12px' lineHeight='14px' color='neutralDark'>
            {owner} - {expirationDate}
          </Text>
        </Flex>
      </Flex>

      {isExpired && (
        <Flex alignItems='center' color='red.500' mt={2}>
          <i data-eva={'alert-triangle'} data-eva-fill={'#FF3D71'}></i>
          <Text marginLeft={'10px'} fontWeight='400' fontSize='12px' lineHeight='16px'>
            {t('expired_card')}
          </Text>
        </Flex>
      )}
    </Box>
  )
}

export { PaymentInfo }
